"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";
import { track } from "@vercel/analytics";
import { toast } from "sonner";
import { LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";

interface UserFooterProps {
  name: string;
  email: string;
  company?: string | null;
}

export function UserFooter({ name, email, company }: UserFooterProps) {
  const router = useRouter();
  const [isSigningOut, setIsSigningOut] = useState(false);

  const handleSignOut = async () => {
    track("sign_out");
    setIsSigningOut(true);
    try {
      await fetch("/api/session/sign-out", { method: "POST" });
      router.refresh();
      window.location.reload();
    } catch (error) {
      console.error("Failed to sign out:", error);
      toast.error("Failed to sign out. Please try again.");
      setIsSigningOut(false);
    }
  };

  return (
    <div className="flex flex-col items-center gap-1 py-4 text-center text-sm text-muted-foreground">
      <span className="text-base">Welcome, <span className="font-semibold">{name}</span></span>
      {company ? (
        <span className="text-sm text-muted-foreground">{company}</span>
      ) : null}
      <span className="text-xs font-mono">{email}</span>
      <Button
        variant="outline"
        size="sm"
        className="mt-2"
        onClick={handleSignOut}
        disabled={isSigningOut}
      >
        <LogOut className="h-4 w-4" />
        {isSigningOut ? "Signing out..." : "Sign Out"}
      </Button>
    </div>
  );
}
